import styled from 'styled-components';
import { Form as FormComponent } from '@unform/web';

import { Button } from '../../../../components/Button';
import { colors } from '../../../../styles/tokens';

export const Header = styled.div`
  margin-bottom: 32px;
`;

export const Title = styled.h2`
  font-size: 32px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.01em;
  margin-bottom: 12px;
`;

export const StatusTag = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  span.dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${colors.primary};
  }

  span.label {
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: ${colors.onSurfaceVariant};
  }
`;

export const Form = styled(FormComponent)`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ContainerLink = styled.div`
  width: 100%;
  text-align: center;
  font-size: 12px;

  color: ${colors.onSurfaceVariant};

  .link {
    text-decoration: none;
    color: ${colors.primary};
    font-weight: 700;
    cursor: pointer;
  }
`;

export const ButtonSignIn = styled(Button)`
  margin-top: 8px;
`;
